import React from 'react'


const Loader = () => {
  return (
    <div id="loading-icon-bx">
      <div className="loading-inner">
        <div className="load-one"></div>
        <div className="load-two"></div>
        <div className="load-three"></div>
      </div>
   </div>
  )
}

export default Loader